import styled from "styled-components";
import UABLogo from "../assets/vectors/uab-logo.svg";
import YoutubeIcon from "../assets/vectors/youtube-white.svg";
import InstagramIcon from "../assets/vectors/instagram-logo-white.svg";
import TwitterIcon from "../assets/vectors/twitter-white.svg";

const Wrapper = styled.div`
  background: #315c89;
  width: calc(100% - 100px);
  padding: 0 50px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  @media screen and (max-width: 600px) {
    width: 100%;
    margin: 0;
    padding: 0;
  }
  & > img {
    height: 50px;
    padding: 20px 0px;

    @media screen and (max-width: 425px) {
      width: 150px;
    }
  }
`;
const Social = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  & > a {
    margin-right: 15px;
    & > img {
      @media screen and (max-width: 425px) {
        width: 20px;
      }
    }
    & > img {
      @media screen and (max-width: 425px) {
        width: 20px;
      }
    }
  }
`;
function Footer() {
  return (
    <Wrapper>
      <img src={UABLogo} alt="uab" width="200" />
      <Social>
        <a href="https://twitter.com/KANAListanbul" target="_blank">
          {" "}
          <img src={TwitterIcon} alt="" width="25" />
        </a>
        <a
          href="https://www.youtube.com/channel/UCl4Q9d6eXbuQl44PKjJEXIg"
          target="_blank"
        >
          {" "}
          <img src={YoutubeIcon} alt="" width="25" />
        </a>
        <a href="https://www.instagram.com/kanalistanbul" target="_blank">
          {" "}
          <img src={InstagramIcon} alt="" width="25" />
        </a>
      </Social>
    </Wrapper>
  );
}
export default Footer;
